import { RadioButtonGroup, SelectMobile } from '@cian/ui-kit';
import * as React from 'react';
import { EAreaPartsField } from '../../../../../enums';

import { RADIO_BUTTON_GROUP_OPTIONS_RENT, RADIO_BUTTON_GROUP_OPTIONS_SALE } from './constants';
import { HandleRadioChange, HandleSelectChange, PriceTypeProps } from './types';

export const PriceType: React.FC<PriceTypeProps> = props => {
  const { isMobile, isSale, value, onChange } = props;

  const handleSelectChange = React.useCallback<HandleSelectChange>(
    value => {
      onChange(EAreaPartsField.PriceType, value);
    },
    [onChange],
  );

  const handleRadioChange = React.useCallback<HandleRadioChange>(
    (_, value) => {
      onChange(EAreaPartsField.PriceType, value);
    },
    [onChange],
  );

  const options = React.useMemo(
    () => (isSale ? RADIO_BUTTON_GROUP_OPTIONS_SALE : RADIO_BUTTON_GROUP_OPTIONS_RENT),
    [isSale],
  );

  if (isMobile) {
    return <SelectMobile size="XS" value={value} options={options} onChange={handleSelectChange} />;
  }

  return <RadioButtonGroup value={value} options={options} onChange={handleRadioChange} />;
};
